import React from "react";
import Chart from "react-apexcharts";

const SparklineChart2 = ({ data }) => {
  const uniqueTopicsCount = new Set(data.map(item => item.topic)).size;
  const labels = [...Array(uniqueTopicsCount).keys()].map(n => `Topic ${n + 1}`);
  const sparklineData = [8, 25, 45, 40, 60, 45, 60, 80, 89, 45, 4, 8, 2];
  const spark2 = {
    chart: {
      id: "sparkline2",
      group: "sparklines2",
      type: "area",
      height: 100,
      sparkline: {
        enabled: true,
      },
    },
    stroke: {
      curve: "straight",
    },
    fill: {
      opacity: 1,
    },
    series: [
      {
        name: "Total Topics",
        data: sparklineData,
      },
    ],
    labels,
    xaxis: {
      type: "category",
    },
    yaxis: {
      min: 0,
    },
    colors: ["#fff"],
    title: {
      text: "Total Topics",
      offsetX: 30,
      style: {
        fontSize: "24px",
        color: "#fff",
        cssClass: "apexcharts-yaxis-title",
      },
    },
    subtitle: {
      text: `${uniqueTopicsCount}`,
      offsetX: 30,
      style: {
        fontSize: "14px",
        color: "#fff",
        cssClass: "apexcharts-yaxis-title",
      },
    },
  };

  return (
    <div>
      <Chart
        options={spark2}
        series={spark2.series}
        type="area"
        width={"100%"}
        height={97}
      />
    </div>
  );
};

export default SparklineChart2;
